import { render, staticRenderFns } from "./menumanagementtable.vue?vue&type=template&id=1162fbc8&scoped=true&"
import script from "./menumanagementtable.vue?vue&type=script&lang=js&"
export * from "./menumanagementtable.vue?vue&type=script&lang=js&"
import style0 from "./menumanagementtable.vue?vue&type=style&index=0&id=1162fbc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1162fbc8",
  null
  
)

export default component.exports